import { LanguageItem } from '../../models/components';

export class LanguageSelector {
    open: boolean = false;
    $refs: any;
    availableLanguages: LanguageItem[] = [{
        title: "EN",
        name: 'English',
    }, {
        title: "FR",
        name: 'French',
    }];
    selectedLanguage: LanguageItem;

    constructor(defaultOnly: boolean = true, currentLangCode: string) {
        if (defaultOnly === true) {
            this.availableLanguages = [this.availableLanguages[0]]
        }

        let lang = this.availableLanguages[0];
        const matched = this.availableLanguages.filter(obj => obj.title.toLowerCase() === currentLangCode)

        if (matched.length === 1) {
            lang = matched[0]
        }

        this.selectedLanguage = lang;
    }

    toggle() {
        if (this.open) {
            return this.close()
        }

        this.$refs.button.focus()

        this.open = true
    }

    close(focusAfter?: HTMLButtonElement) {
        if (!this.open) return

        this.open = false

        focusAfter && focusAfter.focus()
    }

    selectLanguage(langItem: LanguageItem) {
        this.close();

        const previousSelectedLang = this.selectedLanguage;

        if (previousSelectedLang.name == langItem.name) {
            return
        }

        const pathname = window.location.pathname;
        let cleanPathname = `${langItem.title.toLowerCase()}${pathname}`;

        const startsWithLangCode = pathname.startsWith(`/${previousSelectedLang.title.toLowerCase()}/`)

        if (startsWithLangCode) {
            cleanPathname = pathname.replace(`/${previousSelectedLang.title.toLowerCase()}/`, "");
        }

        this.selectedLanguage = langItem;
        window.location.href = `/${cleanPathname}`;
    }
}
